/*SYSTEM IMPORTS*/
import React from 'react'
import './style'
import './media'

/*IMG*/
import Link from "components/Link";
import Img from "components/Img";
import QuotesIcon from './images/quotes.svg'

/*CORES*/
import AppCore from 'cores/AppCore'

const Review = props => (
    <div
        className="review"
        onMouseDown={props.onMouseDown}
        onClick={ props.onOpenModal }
    >
        <div className="review__text">
            <Img src={QuotesIcon} className="review-quotes"/>
            { props.children }

            { props.needCut !== false && <>
                <span className="dots">...</span>
                <Link className="show-more-text">
                    <span>
                        { AppCore.Interfaces.t( "DoctorLanding.Ui.Review.Index.ShowAllText" ) }
                    </span>
                </Link>
            </> }
        </div>
        <div className="review__footer">
            <div className="review__photo">
                <div className="review__name-letter">
                    {props.letter}
                </div>
                {props.photo}
            </div>
            <div className="review__info">
                {props.date && <div className="review__date">
                    {props.date}
                </div>}
                <div className="review__name">
                    {props.name}
                </div>
            </div>
        </div>
    </div>
)

export default Review